export class SessionCounterDto {

    constructor(public user: string, public count: number) {
    }
}
